// Vantaggio Clienti Studio: link personale (?studio=KEY) salvato in localStorage.
// Lo sconto reale è sempre ricalcolato server-side al checkout (FASE 25).
import { useEffect, useState } from "react";
import api from "@/lib/api";

const KEY = "gm_studio_key";
let cache = null;

export function captureStudioKey(search) {
  try {
    const k = new URLSearchParams(search).get("studio");
    if (k && /^[a-f0-9]{32,128}$/.test(k)) localStorage.setItem(KEY, k);
  } catch { /* ignore */ }
}

export function getStudioKey() {
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
}

export function clearStudioKey() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
  cache = null;
}

async function fetchPricing() {
  const key = getStudioKey();
  if (!key) return null;
  if (cache && cache.key === key) return cache.data;
  try {
    const { data } = await api.get(`/studio/${key}/pricing`);
    cache = { key, data };
    return data;
  } catch {
    // link scaduto/revocato: nessun vantaggio mostrato
    clearStudioKey();
    return null;
  }
}

export function useStudio() {
  const [studio, setStudio] = useState(null);
  useEffect(() => { fetchPricing().then(setStudio); }, []);
  const priceFor = (product, price) => {
    if (!studio?.valid || !product) return null;
    if ((studio.excluded_product_ids || []).includes(product.id)) return null;
    return Math.round(price * (100 - studio.percent)) / 100;
  };
  return { studio, priceFor, active: !!studio?.valid, percent: studio?.percent || 0 };
}
